{
    "save": "Salva",
    "cancel": "Annulla",
    "back": "Indietro",
    "next": "Avanti",
    "submit": "Invia",
    "loading": "Caricamento...",
    "language": "Lingua",
    "languageDescription": "Scelga la lingua dei menu, dei pulsanti e dei promemoria.",
    "profile": {
        "title": "Profilo",
        "description": "Gestisca il Suo profilo e le Sue preferenze",
        "contactDetails": "Recapiti",
        "languageGroup": "Lingua",
        "otherActions": "Altre azioni",
        "changePassword": "Modifica la password",
        "logout": "Esci",
        "incompleteTitle": "Profilo incompleto",
        "incompleteMessage": "Per usare Patient Watch, completi prima il Suo profilo compilando tutti i campi indicati come mancanti."
    },
    "nav": {
        "diaries": "Diari"
    }
}
